export default "__VITE_ASSET__BrarploS__"